import _defineProperty from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children", "className"],
    _excluded2 = ["children", "className"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import cn from 'classnames';
import styles from './AlertBanner.module.sass';
import { jsx as _jsx } from "react/jsx-runtime";

/**
 * Renders the content of the alert banner.
 *
 * @author Tom Milewski
 *
 * @example
 * <AlertBanner.Content>
 *   Based on your revenue, it's time to upgrade to Subkit’s Paid Plan.
 *   <Link href="/dashboard/account-settings/billing">
 *     <a>Upgrade now.</a>
 *   </Link>
 * </AlertBanner.Content>
 */
var AlertBannerContent = /*#__PURE__*/React.forwardRef(function (_ref, forwardedRef) {
  var children = _ref.children,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({
    className: cn(styles.content, className)
  }, rest), {}, {
    ref: forwardedRef,
    children: children
  }));
});
/**
 * Renders an alert banner container of a certain
 * color denoting the severity
 *
 * @author Tom Milewski
 *
 * @example
 * <AlertBanner.Root type="error">
 *   <AlertBanner.Content>
 *     Based on your revenue, it's time to upgrade to Subkit’s Paid Plan.
 *     <Link href="/dashboard/account-settings/billing">
 *       <a>Upgrade now.</a>
 *     </Link>
 *   </AlertBanner.Content>
 * </AlertBanner.Root>
 */

var AlertBanner = /*#__PURE__*/React.forwardRef(function (_ref2, forwardedRef) {
  var children = _ref2.children,
      className = _ref2.className,
      rest = _objectWithoutProperties(_ref2, _excluded2);

  return /*#__PURE__*/_jsx("div", {
    className: styles.container,
    children: /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({
      className: cn(styles.root, className)
    }, rest), {}, {
      ref: forwardedRef,
      children: children
    }))
  });
});
var Root = AlertBanner;
var Content = AlertBannerContent;
export { AlertBanner, AlertBannerContent, //
Root, Content };